var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.5707 3.94066L13.6462 0L0.0759277 13.6264V17.5645H4.003L17.5707 3.94066ZM5.08925 14.8133L2.81839 12.533L10.5014 4.81828L12.7722 7.09852L5.08925 14.8133ZM15.9171 3.94066L13.599 6.26832L11.3282 3.98809L13.6462 1.66039L15.9171 3.94066ZM1.2478 16.393V14.1102L1.99159 13.3633L4.26245 15.6436L3.51601 16.3931H1.2478V16.393Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.0759277 18.8281H17.5701V19.9996H0.0759277V18.8281Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.11108 16.3926H17.57V17.564H8.11108V16.3926Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.b43d29d9bfe032be9399ca5efd4707f1.svg";
export { ForwardRef as ReactComponent };